import React, { useEffect, useState } from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { useUnitItemContext } from "@/hooks/useUnitItemContext";

const images = import.meta.glob("/src/assets/icons/*.svg");

interface UnitImageProps {
    length: number;
    width: number;
    className?: string;
}

export const UnitImage = ({ length, width, className }: UnitImageProps) => {
    const [imageSrc, setImageSrc] = useState("");
    const unitItemContext = useUnitItemContext();

    const  category  = unitItemContext.unitGroup.representative_unit.category ?? { image: "" };

    useEffect(() => {
        const loadImage = async (imageUrl: string) => {
            try {
                const img = new Image();
                img.src = imageUrl;
                await new Promise((resolve, reject) => {
                    img.onload = resolve;
                    img.onerror = reject;
                });
        
                setImageSrc(imageUrl);
            } catch (error) {
                console.info(`Error loading image: ${imageUrl}`, error);
            }
        }
        
        if (category.image === "") {
            // Construct the filename based on length and width
            const imageName = `/src/assets/icons/${width}x${length}.svg`;

            if (images[imageName]) {
                images[imageName]().then((module) => {
                    loadImage(module.default);
                });
            } else {
                console.error(`Image not found: ${imageName}`);
            }
        } else {
            loadImage(category.image);
        }
    }, [length, width, category]);

    return imageSrc ? (
        <img
            src={imageSrc}
            alt={`${width}x${length} storage unit`}
            className={className}
        />
    ) : (
        <Skeleton className="tw:h-[75px] tw:w-[75px]" />
    );
};
